<template>
  <div class="standard">
    <div class="left_body">
      <div class="column" style="display:flex; margin-right:10px; margin-bottom:50px;">
        <tw-status-bar v-if="typeof tradeManagement.processProgressStatus === 'number'" :statusCode="tradeManagement.processProgressStatus" :approval="approvalProcess" />
        <tw-from-to :from="from" :to="to" :editableSide="tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? 'from' : 'to'" :processProgressStatus="tradeManagement.processProgressStatus" style="margin-left:10px;" />
        <div class="column">
          <div v-if="!isEditMode" class="process_buton">
            <!-- 画面に収まりきらずスタイルが崩れるため非表示 -->
            <!-- <tw-button v-if="needApplyButton" type="primary" size="small" @click="approvalRequest">{{ applyButtonLabel }}</tw-button> -->
            <!-- <tw-button v-if="needRegisterButton" type="primary" size="small" @click="register">{{$t('Label.Register')}}</tw-button> -->
            <tw-button v-if="needEditButton" type="secondary" size="small" icon="edit" @click="edit">{{$t('Label.Edit')}}</tw-button>
            <el-dropdown trigger="click" placement="bottom-start" @command="onDropDownClick" :tabindex="-1">
              <tw-button v-show="needMenuButton" class="menu_button" type="secondary" size="small" icon="menu">Menu</tw-button>
              <el-dropdown-menu>
                <el-dropdown-item v-if="needReturnButton" command="return">{{$t('Label.Return')}}</el-dropdown-item>
                <el-dropdown-item v-if="needWithdrawButton" command="withdraw">{{$t('Label.Withdraw')}}</el-dropdown-item>
                <el-dropdown-item v-if="needCancelDeleteRequestButton" command="cancelDeleteRequest">{{$t('Label.Cancel')}}</el-dropdown-item>
                <el-dropdown-item v-if="needFromDeleteButton" command="fromDeleteRequest">{{$t('Label.Delete')}}</el-dropdown-item>
                <el-dropdown-item v-if="needToDeleteButton" command="toDeleteRequest">{{$t('Label.Delete')}}</el-dropdown-item>
                <el-dropdown-item v-if="needDeleteSavedDataButton" command="deleteSavedData">{{$t('Label.Delete Save Data')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="isEditMode" class="process_buton">
            <tw-button v-if="editNeedSaveButton" type="secondary" size="medium" @click="editSave">{{$t('Label.Save')}}</tw-button>
            <tw-button v-if="editNeedApplyButton" type="primary" size="medium" @click="editApprovalRequest">{{ applyButtonLabel }}</tw-button>
            <tw-button v-if="editNeedRegisterButton" type="primary" size="medium" @click="editRegister">{{$t('Label.Register')}}</tw-button>
          </div>
        </div>
      </div>
      <el-select v-if="isArchive" v-model="version" @change="changeVersion" placeholder="Select" style="width: 120px;margin-bottom: 22px">
        <el-option
          v-for="version in versions"
          :key="version.version"
          :label="version.version"
          :value="version.processTrx">
        </el-option>
      </el-select>
      <tw-approval-request v-if="needApprovalArea" :tradeManagement="tradeManagement" />
      <div class="milstone">
        <div class="milestone_title">
          <div v-for="s in milestoneSteps" :key="s.key" class="milestone_title_text">
            <el-tooltip v-if="s.description && s.tooltip" v-model="tooltipOpen[s.key]" :manual="true" :content="s.tooltip" placement="top" popper-class="mcu">
              <span @mouseenter="openTooltip(s.key)" @mouseleave="closeTooltip(s.key)">{{$t(`Label.${s.title}`)}}</span>
            </el-tooltip>
            <span v-else>{{$t(`Label.${s.title}`)}}</span>
          </div>
        </div>
        <el-steps :active="0" align-center class="milestone_steps">
          <el-step
            v-for="s in milestoneSteps"
            :key="s.key"
            title=""
            description=""
            :class="s.stepClass"
          >
            <template slot="icon">
              <div class="milestone_tooltip_hit" @mouseenter="openTooltip(s.key)" @mouseleave="closeTooltip(s.key)"/>
            </template>
          </el-step>
        </el-steps>
        <div class="milestone_date">
          <div v-for="s in milestoneSteps" :key="s.key" class="milestone_date_text">
            <span v-if="s.description">{{s.description}}</span>
            <el-tag 
              v-if="s.description"
              size="mini"
              style="margin-left: 6px; padding-right: 8px"
              :type="s.useActual ? 'success' : 'info'"
            >
              {{ s.useActual ? $t('Label.Actual') : $t('Label.Estimated') }}
            </el-tag>
          </div>
        </div>
      </div>
      <div class="standard_tab_header">
        <el-tabs v-model="activeTabGroup" type="card" class="standard_tabs">
          <el-tab-pane
            v-for="tab in standardTabs"
            :key="tab.group"
            :label="$t(`Label.${tab.label}`)"
            :name="tab.group"
          />
        </el-tabs>
        <tw-button
          class="field_setting_button"
          type="secondary"
          plain
          @click="openFieldSettingDialog"
        >
          {{ $t('Label.Field Settings') }}
        </tw-button>
      </div>
      <tw-standard-field-setting-dialog
        :visible="fieldSettingDialogVisible"
        :processId="processId"
        :schemas="schemas"
        :standardTabs="standardTabs"
        :initialTabGroup="dialogInitialTabGroup"
        @close="closeFieldSettingDialog"
      />
      <div class="standard_tab_body">
        <el-form :model="localValue" :rules="rules" ref="form" class="standard_form" :validate-on-rule-change="false">
          <template v-if="isEditMode">
            <div v-for="tab in standardTabs" :key="tab.group" v-show="activeTabGroup === tab.group">
              <template v-if="tab.group === 'Container Details'">
                <tw-process-group-list-infinite
                  v-if="containerTypeSchemaItem"
                  :item="containerTypeSchemaItem"
                  tableName="linkageTransportation"
                  groupName="containerInfoGrp"
                  :isEdit="true"
                  v-model="localValue"
                />
              </template>
              <template v-else-if="tab.group === 'Goods Details'">
                <div class="goods_details_wrap" style="grid-column: 1 / -1; width: 100%;">
                  <table v-if="linkageGoodsLineTable">
                    <tw-process-list
                      :table="linkageGoodsLineTable"
                      :isEditMode="true"
                      v-model="localValue"
                      :fixedOpen="true"
                    />
                  </table>
                  <table v-if="linkageGoodsLinePackingTable">
                    <tw-process-list
                      :table="linkageGoodsLinePackingTable"
                      :isEditMode="true"
                      v-model="localValue"
                      :fixedOpen="true"
                    />
                  </table>
                </div>
              </template>
              <template v-else>
                <template v-for="g in (standardGroupsByTab[tab.group] || [])">
                  <tw-process-group-list-edit
                    v-for="item in g.items"
                    :key="item.key"
                    :item="item"
                    :tableName="g.tableName"
                    :groupName="g.groupName"
                    v-model="localValue"
                    :serialIndexes="serialIndexes"
                    :serialItems="serialItems"
                  />
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <div v-for="tab in standardTabs" :key="tab.group" v-show="activeTabGroup === tab.group">
              <template v-if="tab.group === 'Container Details'">
                <tw-process-group-list-infinite
                  v-if="containerTypeSchemaItem"
                  :item="containerTypeSchemaItem"
                  tableName="linkageTransportation"
                  groupName="containerInfoGrp"
                  :isEdit="false"
                  :value="localValue"
                />
              </template>
              <template v-else-if="tab.group === 'Goods Details'">
                <div class="goods_details_wrap" style="grid-column: 1 / -1; width: 100%;">
                  <table v-if="linkageGoodsLineTable">
                    <tw-process-list
                      :table="linkageGoodsLineTable"
                      :isEditMode="false"
                      :value="localValue"
                      :fixedOpen="true"
                    />
                  </table>
                  <table v-if="linkageGoodsLinePackingTable">
                    <tw-process-list
                      :table="linkageGoodsLinePackingTable"
                      :isEditMode="false"
                      :value="localValue"
                      :fixedOpen="true"
                    />
                  </table>
                </div>
              </template>
              <template v-else>
                <tw-process-group-list-item-standard v-for="displayItem in standardDisplaySchemasMap[tab.group]" :key="displayItem.item.key" :item="displayItem.item" :tableName="displayItem.tableName" :groupName="displayItem.groupName" :value="localValue" :isEditMode="isEditMode"/>
              </template>
            </div>
          </template>
        </el-form>
        <template v-if="activeTabGroup === 'Schedule' && this.processType === PROCESS_TYPE.ICREQ">
          <div class="table_name full" style="border: 0;padding-top: 24px;margin-bottom: 10px">Delivery Order In Charge</div>
          <tw-process-group-list-edit-delivery-table v-model="localValue" :is-edit-mode="isEditMode" @open-modal="showDeliveryModal = true" />
          <div v-if="s.res.deliveryOrder.otherDeliveryOrderList.length" class="table_name full" style="border: 0;padding-top: 24px;margin-bottom: 10px">Others</div>
          <tw-process-group-list-edit-delivery-table  v-if="s.res.deliveryOrder.otherDeliveryOrderList.length" :is-edit-mode="isEditMode" :is-other="true" @open-modal="showOtherDeliveryModal = true"/>
          <tw-process-group-list-edit-delivery-table-modal :visible.sync="showDeliveryModal" :delivery-order-list="s.res.deliveryOrder.deliveryOrderList" :is-other="false" />
          <tw-process-group-list-edit-delivery-table-modal :visible.sync="showOtherDeliveryModal" :delivery-order-list="s.res.deliveryOrder.otherDeliveryOrderList" :is-other="true" />
        </template>
      </div>
    </div>
    <div class="center_body">
      <tw-communication @reconfirm="reconfirm" classMode="standard"/>
    </div>
    <div class="right_body">
      <tw-documents classMode="standard" @update-attached-files="updateAttachedFiles" @save="(action, documents) => $emit('save', action, documents)" @approval-request="(action, documents) => $emit('approval-request', action, documents)" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { PROCESS_OPERATION, RESPONSIBLE_FLG, ABLE_FLG, PROCESS_TYPE, PROCESS_PROGRESS_STATUS, LANGUAGE_SETTING} from 'lib-tw-common';
import TwCommunication from '@/components/organisms/TwCommunication';
import TwDocuments from '@/components/organisms/TwDocuments';
import TwApprovalRequest from '@/components/organisms/TwApprovalRequest';
import TwButton from '@/components/atoms/TwButton';
import TwStatusBar from '@/components/atoms/TwStatusBar';
import TwFromTo from '@/components/molecules/TwFromTo';
import TwProcessGroupListItemStandard from '@/components/molecules/TwProcessGroupListItemStandard.vue';
import TwStandardFieldSettingDialog from '@/components/molecules/TwStandardFieldSettingDialog.vue';
import standardTabs from '@/dictionaries/standardTabsSchema.json';
import TwProcessGroupListEditDeliveryTable from '@/components/molecules/TwProcessGroupListEditDeliveryTable';
import TwProcessGroupListEditDeliveryTableModal from '@/components/molecules/TwProcessGroupListEditDeliveryTableModal';
import TwProcessGroupListEdit from '@/components/molecules/TwProcessGroupListEdit';
import TwProcessGroupListInfinite from '@/components/molecules/TwProcessGroupListInfinite';
import TwProcessList from '@/components/organisms/TwProcessList';



export default {
  name: 'TwProcessDetailStandard',
  inject: ['s'],
  provide() {
    return {
      s: this.s,
      tab: null,
      activeTab: { value: null},
      isStandardMode: true,
    };
  },
  props: {
    schemas: Object,
    milestoneSchema: Array,
    value: Object,
    isArchive: Boolean,
    versions: Array,
    versionNo: [String, Number],
    from: Object,
    to: Object,
    roles: Object,
    tradeManagement: Object,
    bcStatus: Number,
    approvalProcess: Boolean,
    processId: String,
    processType: String,
    rules: Object,
    initialOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: { 
    TwCommunication,
    TwDocuments,
    TwApprovalRequest,
    TwButton,
    TwStatusBar,
    TwFromTo,
    TwProcessGroupListItemStandard,
    TwStandardFieldSettingDialog,
    TwProcessGroupListEditDeliveryTable,
    TwProcessGroupListEditDeliveryTableModal,
    TwProcessGroupListEdit,
    TwProcessGroupListInfinite,
    TwProcessList
  },
  data() {
    return {
      version: this.versionNo ? parseInt(this.versionNo) : null,
      isEditMode: false,
      RESPONSIBLE_FLG,
      standardTabs,
      activeTabGroup: "Schedule",
      fieldSettingDialogVisible: false,
      showDeliveryModal: false,
      showOtherDeliveryModal: false,
      tooltipOpen: {},
      serialIndexes: {},
      serialItems: {},
      activeTabProxy: { value: null },
      tabProxy: { value: null },
      lastUpdateDate: null,
      PROCESS_TYPE
    };
  },
  mounted () {
    this.bridgeParentForm();
  },
  watch: {
    schemas: {
      immediate: true,
      handler(newSchemas) {
        if(!newSchemas || !Array.isArray(newSchemas.tables)) return;
        this.initializeStandardFieldLayout();
      }
    },
    activeTabGroup: {
      immediate: true,
      handler(v) {
        this.activeTabProxy.value = v;
        this.tabProxy.value = v;
      }
    },
    'tradeManagement.updateDate': {
      handler(next) {
      // 初回セットは無視
      if (this.lastUpdateDate == null) {
        this.lastUpdateDate = next;
        return;
      }

      // updateDate が変わった = 保存/承認などが成功して再取得された可能性が高い
      if (next !== this.lastUpdateDate && this.isEditMode) {
        this.isEditMode = false;
      }
      this.lastUpdateDate = next;
      },
      immediate: true,
    },
    'tradeManagement.processProgressStatus': {
      handler(newVal, oldVal) {
        if(oldVal !== undefined && newVal !== oldVal && this.isEditMode) {
          this.isEditMode = false;
        }
      }
    }
  },
  computed: {
    dialogInitialTabGroup() {
      const excluded = new Set(['Container Details', 'Goods Details']);
      return excluded.has(this.activeTabGroup) ? 'Schedule' : this.activeTabGroup;
    },
    linkageGoodsLineTable() {
      if (!this.schemas || !Array.isArray(this.schemas.tables)) return null;
      const table = this.schemas.tables.find(t => t.variableName === 'linkageGoodsLine') || null;
      if (!table) return null;
      return { ...table, name: this.$t('Label.Goods Details Line') };
    },
    linkageGoodsLinePackingTable() {
      if (!this.schemas || !Array.isArray(this.schemas.tables)) return null;
      const table = this.schemas.tables.find(t => t.variableName === 'linkageGoodsLinePacking') || null;
      if (!table) return null;
      return { ...table, name: this.$t('Label.Goods Line Packing') };
    },
    containerTypeSchemaItem() {
      const tables = this.schemas && Array.isArray(this.schemas.tables) ? this.schemas.tables : [];
      for (const table of tables) {
        if (table.variableName !== 'linkageTransportation') continue;
        for (const group of (table.groups || [])) {
          if (group.variableName !== 'containerInfoGrp') continue;
          const item = (group.children || []).find(c => c.key === 'containerType');
          if (item) return item;
        }
      }
      return null;
    },
    standardGroupsByTab() {
      const out = {};
      (this.standardTabs || []).forEach(tab => {
        const list = (this.standardDisplaySchemasMap?.[tab.group] || []);
        out[tab.group] = list.map((x) => ({
          tableName: x.tableName,
          groupName: x.groupName,
          items: [x.item],
        }));
        // TrackingタブのcontainerNoをcontainerType（standardGroup付き）に置き換えてTwProcessGroupListInfiniteで表示
        if (tab.group === 'Tracking' && this.containerTypeSchemaItem) {
          const containerTypeEntry = {
            tableName: 'linkageTransportation',
            groupName: 'containerInfoGrp',
            items: [{ ...this.containerTypeSchemaItem, standardGroup: 'Tracking' }],
          };
          const idx = out[tab.group].findIndex(g => g.items.some(item => item.key === 'containerNo'));
          if (idx !== -1) {
            out[tab.group][idx] = containerTypeEntry;
          } else {
            // standardDisplaySchemasMapに含まれていない場合はtabNo=3の位置に挿入
            const insertIdx = out[tab.group].findIndex(g => g.items.some(item => Number(item.tabNo || 0) > 3));
            if (insertIdx !== -1) {
              out[tab.group].splice(insertIdx, 0, containerTypeEntry);
            } else {
              out[tab.group].push(containerTypeEntry);
            }
          }
        }
      });
      return out;
    },
    isEnglish() {
      return this.$store.state.language === LANGUAGE_SETTING.ENGLISH; 
    },
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    // To下書き削除ボタンの表示可否を返却します
    needDeleteSavedDataButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return !this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING_DEL);
    },
    // ToDeleteボタンの表示可否を返却します
    needToDeleteButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING_DEL);
    },
    // FromDeleteボタンの表示可否を返却します
    needFromDeleteButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_SAVING_DEL);
    },
    // 削除取り消しボタンの表示可否を返却します
    needCancelDeleteRequestButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK);
    },
    // Withdrawボタンの表示可否を返却します
    needWithdrawButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      // Todo: APIのtradeManagement.actionsでAGREEDステータスのCO申請にPROCESS_OPERATION.F_PULL_BACKの値が返却されないよう修正されたら削除する
      // CO申請にPROCESS_PROGRESS_STATUS.DONEは存在しないためAGREEDの場合のみ非表示
      if (this.processType === PROCESS_TYPE.FDCOR
        && this.tradeManagement.processProgressStatus === PROCESS_PROGRESS_STATUS.AGREED) {
        return false;
      }

      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_PULL_BACK);
    },
    // Returnボタンの表示可否を返却します
    needReturnButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      // To担当者に表示
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_RECONFIRMATION);
    },
    // Editボタンの表示可否を返却します
    // ブロックチェーン書き込み実行後・Delete後は非表示。担当者ロール以外のユーザーは非表示
    needEditButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.editAbleFlg === ABLE_FLG.TRUE;
    },
    // Registerボタンの表示可否を返却します
    // 非承認プロセス時 To担当者に表示
    needRegisterButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_DONE);
    },
    // Applyボタンの表示可否を返却します
    // 「承認プロセス」Delete申請時 To担当
    // 「承認プロセス」で通常の申請時 To担当者（To側にTo側限定の入力必須項目がない場合）
    //   →厳密に言うとプロセス変更画面にTo担当者の入力「必須」項目が無い場合だが、現状全部ない。
    needApplyButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      // 「承認プロセス」Delete申請時以外は非表示
      if (this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM) {
        // Fromにボールがあるときは非表示
        return false;
      }
      // TO承認依頼が操作可能であれば表示
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE_REQ);
    },
    // 承認部品の表示可否を返却します
    needApprovalArea() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_APPROVE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.F_REMAND) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_REMAND);
    },
    // Applyボタンの表示可否を返却します
    editNeedApplyButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_APPROVE_REQ) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE_REQ);
    },
    // Saveボタンの表示可否を返却します
    editNeedSaveButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_SAVING) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING);
    },
    // Registerボタンの表示可否を返却します
    editNeedRegisterButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_DONE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_DONE);
    },
    applyButtonLabel() {
      if (this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.TO) {
        return this.$t('Label.Apply(Awaiting Confirmation(To))');
      } else {
        return this.$t('Label.Apply(NotStarted/InputInProgress)');
      }
    },
    needMenuButton() {
      return (
        this.needReturnButton ||
        this.needWithdrawButton ||
        this.needCancelDeleteRequestButton ||
        this.needFromDeleteButton ||
        this.needToDeleteButton ||
        this.needDeleteSavedDataButton
      );
    },
    milestoneSteps () {
      const now = new Date();

      return (this.milestoneSchema || []).map(mile => {
        const basicPath = mile.basicPath;
        const actualPath = mile.actualPath;

        const basicDate = this.parseDate(this.getValueByPath(this.localValue, basicPath));
        const actualDate = this.parseDate(this.getValueByPath(this.localValue, actualPath));

        const useActual = !!actualDate && (now.getTime() >= actualDate.getTime());
        const displayDate = useActual ? actualDate: basicDate;

        const tooltipPath = useActual ? actualPath : basicPath;
        const tooltipKey = this.getLastPathKey(tooltipPath);
        const schemaItem = this.findSchemaByKey(tooltipKey);
        const tooltipText = schemaItem ? (this.isEnglish ? schemaItem.label : schemaItem.jpLabel) : '';

        return {
          key: mile.key,
          title: mile.title,
          description: displayDate ? this.formatDate(displayDate) : '',
          stepClass: useActual ? 'is-blue' : '',
          tooltip: tooltipText,
          useActual,
        };
      });
    },
    standardDisplaySchemasMap() {
      const map = {};
      (this.standardTabs || []).forEach(tab => {
        map[tab.group] = this.standardDisplaySchemas(tab.group);
      });
      return map
    },
    standardFieldLayout: {
      get() {
        return this.$store.getters.getStandardFieldLayout(this.processId) || null;
      },
      set(layout) {
        this.$store.commit('SET_STANDARD_FIELD_LAYOUT', {
          processId: this.processId,
          layout,
        });
      }
    },
    isMilestoneTooltipEnabled() {
      return (this.milestoneSteps || []).some(s => this.isStepTooltipEnabled(s));
    }
  },
  methods: {
    bridgeParentForm() {
      if(!this.s || !this.$refs.form) return;
      this.s.$refs = this.s.$refs || {};
      this.s.$refs.form = this.$refs.form;
    },
    edit() {
      this.isEditMode = true;
      this.s.mode = 'edit';
    },
    // 承認依頼
    approvalRequest() {
      const action = PROCESS_OPERATION.T_APPROVE_REQ;
      if (this.tradeManagement.eventCancel) {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('approval-request', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else {
        this.$emit('approval-request', action, this.createPostDocuments());
      }
    },
    // 承認依頼
    editApprovalRequest() {
      this.quantityOverAlert().then(() => {
        const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_APPROVE_REQ : PROCESS_OPERATION.T_APPROVE_REQ;
        this.$emit('approval-request', action, this.createPostDocuments());
      })
      .catch(() => {
        return false;
      });
    },
    register() {
      const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_DONE : PROCESS_OPERATION.T_DONE;
      if (this.tradeManagement.eventCancel && action === PROCESS_OPERATION.T_DONE) {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('register', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else {
        this.$emit('register', action, this.createPostDocuments());
      }
    },
    // 登録
    editRegister() {
      this.quantityOverAlert().then(() => {
        const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_DONE : PROCESS_OPERATION.T_DONE;
        this.$emit('register', action, this.createPostDocuments());
      })
      .catch(() => {
        return false;
      });
    },
    // 下書き保存
    editSave() {
      this.quantityOverAlert().then(() => {
        const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_SAVING : PROCESS_OPERATION.T_SAVING;
        this.$emit('save',  action, this.createPostDocuments());
      })
      .catch(() => {
        return false;
      });
    },
    onDropDownClick(command) {
      if (command === 'return') {
        const action = PROCESS_OPERATION.T_RECONFIRMATION;
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_RETURN'))
          .then(() => {
            this.$emit('withdraw', action);
          })
          .catch(() => {});
      } else if (command === 'withdraw') {
        const action = this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK) ? PROCESS_OPERATION.F_PULL_BACK : PROCESS_OPERATION.T_PULL_BACK;
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_WITHDRAW'))
          .then(() => {
            this.$emit('withdraw', action);
          })
          .catch(() => {});

      } else if (command === 'fromDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            // From削除申請、下書き削除
            this.$emit('delete-draft');
          })
          .catch(() => {});
      } else if (command === 'toDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            // To削除申請
            const action = PROCESS_OPERATION.T_SAVING_DEL;
            this.$emit('approval-request', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else if (command === 'deleteSavedData') {
        // To下書き削除
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('delete-draft');
          })
          .catch(() => {});
      } else if (command === 'cancelDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_CANCEL_DELETE_REQUEST'))
          .then(() => {
            const action = PROCESS_OPERATION.F_PULL_BACK;
            this.$emit('withdraw', action);
          })
          .catch(() => {});
      }
    },
    updateAttachedFiles() {
      this.$emit("update-attached-files");
    },
    reconfirm() {
      this.$emit('withdraw', PROCESS_OPERATION.T_RECONFIRMATION);
    },
    changeVersion(version) {
      if (version !== this.tradeManagement.processTrx) {
        this.$emit('change-version', this.version);
      }
    },
    // サブフローで親フローの商品の数量を超えていた場合のアラート
    async quantityOverAlert() {
      if (!this.isSubFlow) return Promise.resolve()
      let result = true
      if (this.localValue.linkageGoodsLine && this.parentGoodsLine.length) {
        _.forEach(this.parentGoodsLine, item => {
          // 親の合計数量
          const parentQuantity = item.quantityGrp.quantity1 || 0
          // 親と同じprevGoodsLineId、prevGoodsLineSeqを持つ子のグッズ
          const childGoods = _.filter(this.localValue.linkageGoodsLine, goods => {
            return goods.goodsGrp.prevGoodsLineId === item.goodsGrp.prevGoodsLineId && goods.goodsGrp.prevGoodsLineSeq === item.goodsGrp.prevGoodsLineSeq;
          })
          if (!childGoods || !childGoods.length) return
          // 子の数量合計
          const childQuantity = _.reduce(childGoods, (total, child) => {
            total = (child.quantityGrp.quantity1 || 0) + total
            return total;
          }, 0);
          if (parentQuantity < childQuantity) {
            result = false
            return false
          }
        });
      }
      if (result) return Promise.resolve()
      else {
        await this.$store.dispatch('SHOW_CONFIRM', this.$t('Message.ERROR__QUANTITY_EXCEEDED'))
          .then(() => { return Promise.resolve() })
          .catch(() => { return Promise.reject() })
      }
    },
    createPostDocuments() {
      return [];
    },
    getValueByPath(val, path) {
      if(!val || !path) return undefined;
      return path.split('.').reduce((current, key) => (current ? current[key] : undefined), val);
    },
    parseDate(val) {
      if (!val) return null;
      if (val instanceof Date) return isNaN(val.getTime()) ? null : val;

      const valueString = String(val);
      const match = valueString.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        return new Date(
          Number(match[1]),
          Number(match[2]) - 1,
          Number(match[3])
        );
      }

      const parsedDate = new Date(valueString);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}/${month}/${day}`;
    },
    openFieldSettingDialog () {
      this.fieldSettingDialogVisible = true;
    },
    closeFieldSettingDialog () {
      this.fieldSettingDialogVisible = false;
    },
    getCurrentTabLayout(tabGroup) {
      const layout = this.standardFieldLayout;
      if (!layout) return { visible: [], hidden: []};

      const key = tabGroup || this.activeTabGroup;
      const tabLayout = layout[key];
      const visible = tabLayout && Array.isArray(tabLayout.visible) ? tabLayout.visible : [];
      const hidden = tabLayout && Array.isArray(tabLayout.hidden) ? tabLayout.hidden : [];
      return { visible, hidden};
    },
    initializeStandardFieldLayout() {
      const schemaKeysByTab = this.collectSchemaKeysByTab();
      const savedLayout = this.standardFieldLayout;

      const normalized = this.normalizeFieldLayout(savedLayout, schemaKeysByTab);

      if (!_.isEqual(savedLayout, normalized)) {
        this.standardFieldLayout = normalized;
      }
    },
    collectSchemaKeysByTab() {
      const result = {
        Overview: [],
        Tracking: [],
        Schedule: [],
        Transship: [],
        Others: []
      };

      const tables = this.schemas && Array.isArray(this.schemas.tables) ? this.schemas.tables : [];

      tables.forEach(table => {
        (table.groups || []).forEach(group => {
          (group.children || []).forEach(item => {
            const standardGroup = typeof item.standardGroup === "string" ? item.standardGroup : "";

            if (standardGroup === "") return

            if(!Object.prototype.hasOwnProperty.call(result, standardGroup)) return;

            if (this.isForceHiddenStandardItem(item)) return;

            result[standardGroup].push(item);
          });
        });
      });

      // Trackingタブ：containerNoをtabNo=3として追加（スキーマのstandardGroupに依存しない）
      if (!result['Tracking'].some(item => item.key === 'containerNo')) {
        tables.forEach(table => {
          if (table.variableName !== 'linkageTransportation') return;
          (table.groups || []).forEach(group => {
            if (group.variableName !== 'containerInfoGrp') return;
            const containerNoItem = (group.children || []).find(c => c.key === 'containerNo');
            if (containerNoItem) result['Tracking'].push({ ...containerNoItem, tabNo: 3 });
          });
        });
      }

      Object.keys(result).forEach(tabGroup => {
        result[tabGroup] = result[tabGroup].slice().sort((a, b) => (a.tabNo == null ? Infinity : Number(a.tabNo)) - (b.tabNo == null ? Infinity : Number(b.tabNo))).map(item => item.key);
      });

      return result;
    },
    normalizeFieldLayout(savedLayout, schemaKeysByTab) {
      const normalized = {};

      Object.keys(schemaKeysByTab).forEach(tabGroup => {
        const schemaKeys = schemaKeysByTab[tabGroup];
        const schemaKeySet = new Set(schemaKeys);

        const savedTab = savedLayout && savedLayout[tabGroup] ? savedLayout[tabGroup] : null;

        const savedVisible = savedTab && Array.isArray(savedTab.visible) ? savedTab.visible : [];
        const savedHidden = savedTab && Array.isArray(savedTab.hidden) ? savedTab.hidden : [];

        const visibleFiltered = savedVisible.filter(key => schemaKeySet.has(key));
        const hiddenFiltered = savedHidden.filter(key => schemaKeySet.has(key));

        const usedSet = new Set([...visibleFiltered, ...hiddenFiltered]);
        const newKeys = schemaKeys.filter(key => !usedSet.has(key));

        normalized[tabGroup] = {
          visible:visibleFiltered.concat(newKeys),
          hidden: hiddenFiltered
        };
      });

      return normalized;
    },
    getLastPathKey(path) {
      if(!path) return '';
      const parts = String(path).split('.');
      return parts[parts.length - 1] || '';
    },
    isEmptyValue(v) {
      if (v === null || v === undefined) return true;
      if(typeof v === 'string') return v.trim() === '';
      if(Array.isArray(v)) return v.length === 0;
      return false
    },
    getValueByProp(obj, prop) {
      if(!obj || !prop) return undefined;
      return _.get(obj, prop);
    },
    openTooltip(key) {
      this.$set(this.tooltipOpen, key, true);
    },
    closeTooltip(key) {
      this.$set(this.tooltipOpen, key, false);
    },
    findSchemaByKey(schemaKey) {
      const tables = this.schemas && Array.isArray(this.schemas.tables) ? this.schemas.tables : [];
      for (const table of tables) {
        for (const group of (table.groups || [])) {
          for (const item of (group.children || [])) {
            if (item && item.key === schemaKey) return item;
          }
        }
      }
      return null;
    },
    isForceHiddenStandardItem(item) {
      const code = item?.code;
      return code === 'SYS_MST_UNIT' || code === 'SYS_MST_CURRENCY';
    },
    standardDisplaySchemas(tabGroup) {
      const activeTab = tabGroup;

      const tables = (this.schemas && Array.isArray(this.schemas.tables)) ? this.schemas.tables : [];

      // hidden は常に適用
      const { visible, hidden } = this.getCurrentTabLayout(activeTab);
      const hiddenSet = new Set(Array.isArray(hidden) ? hidden : []);

      // tabNo順のキー配列（タブ全体）
      const schemaKeysByTab = this.collectSchemaKeysByTab();
      const defaultKeys = schemaKeysByTab[activeTab] || [];

      const allItems = [];
      tables.forEach((table, tableIndex) => {
        (table.groups || []).forEach((group, groupIndex) => {
          (group.children || []).forEach((item, itemIndex) => {
            const standardGroup = item && typeof item.standardGroup === 'string' ? item.standardGroup : '';
            if (!standardGroup || standardGroup !== activeTab) return;
            if (this.isForceHiddenStandardItem(item)) return;

            allItems.push({
              item,
              tableName: table.variableName,
              groupName: group.variableName,
              __idx: `${tableIndex}.${groupIndex}.${itemIndex}`
            });
          });
        });
      });

      // Trackingタブ：containerInfoGrpのcontainerNoをtabNo=3として追加（スキーマのstandardGroupに依存しない）
      if (activeTab === 'Tracking' && !hiddenSet.has('containerNo')) {
        for (const table of tables) {
          if (table.variableName !== 'linkageTransportation') continue;
          for (const group of (table.groups || [])) {
            if (group.variableName !== 'containerInfoGrp') continue;
            const containerNoItem = (group.children || []).find(c => c.key === 'containerNo');
            if (containerNoItem && !allItems.some(r => r.item.key === 'containerNo')) {
              allItems.push({
                item: { ...containerNoItem, tabNo: 3 },
                tableName: 'linkageTransportation',
                groupName: 'containerInfoGrp',
                __idx: 'tracking-containerNo-inject'
              });
            }
            break;
          }
          break;
        }
      }

      // 表示対象（hidden除外）
      const display = allItems.filter(record => !hiddenSet.has(record.item.key));

      const byKey = new Map(display.map(record => [record.item.key, record]));

      // default（tabNo順）から、存在するものだけに絞る
      const defaultFilteredKeys = defaultKeys.filter(key => byKey.has(key));

      // 保存済み visible から、存在するものだけに絞る
      const visibleFilteredKeys = (Array.isArray(visible) ? visible : []).filter(key => byKey.has(key));

      // 配列一致判定
      const isSameArray = (arrayA, arrayB) => {
        if (arrayA.length !== arrayB.length) return false;
        for (let index = 0; index < arrayA.length; index++) if (arrayA[index] !== arrayB[index]) return false;
        return true;
      };

      // visible が空 もしくは default と同じ並びなら初期扱い
      const hasCustomOrder =
        visibleFilteredKeys.length > 0 && !isSameArray(visibleFilteredKeys, defaultFilteredKeys);

      // 使う順序キー：初期はtabNo順、入れ替え後は visible順
      const orderedKeys = hasCustomOrder ? visibleFilteredKeys : defaultFilteredKeys;

      const ordered = orderedKeys.map(key => byKey.get(key)).filter(Boolean);

      // ordered に入ってない残りをtabNo昇順で末尾に追加
      const used = new Set(orderedKeys);
      const rest = display
        .filter(record => !used.has(record.item.key))
        .slice()
        .sort((recordA, recordB) => {
          const numA = (recordA.tabNo === null || recordA.tabNo === undefined) ? 0 : Number(recordA.tabNo);
          const numB = (recordB.tabNo === null || recordB.tabNo === undefined) ? 0 : Number(recordB.tabNo);
          if (numA !== numB) return numA - numB;
          return recordA.__idx.localeCompare(recordB.__idx); // 同tabNoの安定化
        });

      return ordered.concat(rest);
    },
  }
};
</script>

<style lang="scss" scoped>
  .standard {
    display: flex;
  }
  .left_body {
    width: 54%;
    max-height: calc(100vh - 220px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .center_body {
    width: 27%;
    margin-left: 10px;
    margin-right: 10px;
    max-height: calc(100vh - 220px);
    overflow-y: auto;
  }
  .right_body {
    width: 19%;
    margin-left: auto;
    max-height: calc(100vh - 220px);
    overflow-y: auto;
  }
  .column {
    display: flex; 
    align-items:center;
  }
  .process_buton {
    margin-left: 20px;
  }
  .standard_tab_header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .standard_tabs {
    flex: 1;
    min-width: 0;
  }
  .field_setting_button {
    white-space: nowrap;
    font-size: 12px;
  }
  .milstone {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 30px;
  }
  .milestone_title, .milestone_date {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .milestone_title_text, .milestone_date_text {
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
    box-sizing: border-box;
    word-break: break-word;
  }
  .milestone_title_text {
    font-weight: bold;
  }
  .milestone_date_text span{
    font-size: 12px;
  }
  .standard_tab_body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
  .standard_form {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 16px;
    row-gap: 8px;
    align-items: start;
  }
  .milestone_tooltip {
    margin-bottom: 8px;
  }
  .milestone_tooltip_hit {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
</style>

<style lang="scss">
  .milestone_steps {
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .milestone_steps .el-step {
    flex: 1 1 0;
    min-width: 0;
  }
  .milestone_steps .el-step.is-blue .el-step__icon {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }
  .milestone_steps .el-step.is-red .el-step__icon {
    background: #f56c6c;
    border-color: #f56c6c;
    color: #fff;
  }
  .milestone_steps .el-step__icon-inner {
    display: none;
  }
  .standard_form > div {
    display: contents;
  }
  .standard_form .el-form-item{
    display: flex;
    align-items: flex-start;
    width: 100% !important;
    min-width: 100% !important;
  }
  .standard_form .el-form-item__label {
    white-space: normal;
    line-height: 16px !important;
    width: 90px !important;
    text-align: left;
  }
  .standard_form .el-input {
    width: 100% !important;
  }
  .standard_form .tw_process_group_list_edit_item .el-form-item__content .narrow{
    width: 60% !important;
  }
  .standard_form .el-select.unit{
    width: 30% !important;
  }
  .standard_form .el-form-item__content{
    flex: 1;
  }
  .standard_form .tw_process_group_list_edit_item .el-input-number {
    width: 100% !important;
  }
  .standard_form .el-select {
    width: 100% !important;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item {
    height: auto !important;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item label.el-form-item__label {
    width: 90px !important;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content {
    display: flex !important;
    align-items: center;
    flex-wrap: nowrap;
    min-width: 0;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .el-input {
    flex: 1;
    width: auto !important;
    min-width: 0;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .el-select:not(.unit) {
    flex: 1;
    width: auto !important;
    min-width: 0;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .el-select.unit {
    flex: none;
    width: 80px !important;
    margin-left: 8px;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .el-input-number {
    flex: 1;
    width: auto !important;
    min-width: 0;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .el-radio-group {
    flex: 1;
    width: auto !important;
  }
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .add_button,
  .standard_form .tw_process_group_list_infinite .el-form-item__content > .remove_button {
    flex-shrink: 0;
    margin-left: 8px;
  }
  .standard_form .tw_process_group_list_item {
    width: 100% !important;
    min-width: unset !important;
    margin-bottom: 0;
  }
  .standard_form .tw_process_group_list_item .label {
    width: 90px !important;
    min-width: 90px !important;
    white-space: normal;
    line-height: 16px !important;
    font-size: 14px !important;
  }
  .standard_form .el-form-item__content div.show_word_limit.el-input {
    width:100% !important;
  }
  .standard_tabs .el-tabs__item {
    color: $color_gray_600;
    background: $color_gray_300;
  }
  .standard_tabs .el-tabs__item.is-active {
    color: $color_gray_800;
    background: #fff;
  }
  .standard_tab_body .el-form-item__content {
    width: 100%;
    line-height: 1.2;
  }
  .milestone_tooltip .el-tooltip__popper {
    transform: translateY(-4px);
  }
  .milestone_date .el-tag--success {
    color: $color_dark_blue;
    background: #eef3f9;
   border-color: $color_dark_blue;
  }
  .milestone_date .el-tag--info {
    color: #333;
   border-color: #d3d4d6;
  }
  .goods_details_wrap .tw_process_list {
    box-shadow: none !important;
    background: transparent !important;
  }
  .goods_details_wrap .tw_process_list .inner {
    pointer-events: none;
    cursor: default;
  }
  .goods_details_wrap .tw_process_list .inner td.arrow {
    display: none !important;
  }
  .goods_details_wrap .tw_process_list.open .inner {
    box-shadow: none !important;
  }
  .goods_details_wrap .tw_process_group_list_item {
    width: 50% !important;
    margin-bottom: 8px !important;
    min-width: unset !important;
  }
  .goods_details_wrap .tw_process_group_list_item.full {
    width: 100% !important;
  }
  .goods_details_wrap .el-form-item {
    margin-bottom: 8px !important;
    min-height: unset !important;
  }
  .goods_details_wrap .el-form-item label.el-form-item__label {
    width: 90px !important;
    font-size: 14px !important;
    line-height: 16px !important;
  }
  .goods_details_wrap .goods_line_type_table .el-form-item label.el-form-item__label {
    height: 40px !important;
    padding-top: 0 !important;
  }
  .goods_details_wrap .goods_line_type_table .el-form-item__content {
    display: flex;
    flex-wrap: wrap;
  }
  .goods_details_wrap .goods_line_type_table .el-input .el-input__inner {
    min-height: 40px;
  }

</style>
